import axios from "axios";

const API_URL = "https://doshfebackend.teemah.com.ng/api/auth/";
// const API_URL = "http://127.0.0.1:8000/api/auth/";

const login = (username, password) => {
  return axios
    .post(API_URL + "token/", { username, password })
    .then((response) => {
      if (response.data.access) {
        localStorage.setItem("user", JSON.stringify(response.data));
        window.dispatchEvent(new Event("userUpdated")); // 🔥 Notify listeners
      }
      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
  window.dispatchEvent(new Event("userUpdated")); // 🔥 Notify listeners
};

// ✅ This function safely gets the user from localStorage
const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user")) || null;
};

// 🔹 New function to manually update user state
// ✅ This function allows manually updating the user
const setCurrentUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
  window.dispatchEvent(new Event("userUpdated"));
};

export default {
  login,
  logout,
  getCurrentUser,
  setCurrentUser,
};
